import styled from 'styled-components'

import { lightScrollbarInChromeStyle } from '../../../utils/styles/lightScrollbarInChrome.styles'
import Container from '../../layout/Container/Container'

export const NavTabsContent = styled.div`
  display: flex;
  flex-grow: 1;
  padding: ${props => props.theme.spacings.small} 0 0;
  border-bottom: 1px solid ${props => props.theme.colors.primary.base};
`

export const StyledNavTabs = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${props => props.theme.colors.secondary.lightest};

  margin-top: 0;
  flex-wrap: nowrap;
  overflow-x: overlay;

  ${lightScrollbarInChromeStyle}
`

export const StyledNavContainer = styled(Container)`
  & {
    max-width: none;
    min-width: var(--container-width);
    width: max-content;
  }
`
